import React from 'react'
import { useSelector } from 'react-redux'
import { ServiciosItem } from './ServiciosItem'
import { serviciosProveedorReduce } from './serviciosProveedorReduce'

export const Servicios = ({ proveedor }) => {
    const { asistenciasMes } = useSelector(state => state.reportesReducer)
    const listado = serviciosProveedorReduce(asistenciasMes, proveedor.Id)

    return (
        <div style={{ padding: 5, borderBottom: '1px solid #ccc' }}>
            {listado.map((reg, i) => <ServiciosItem reg={reg} key={i} />)}
        </div>
    )
}
